import React from 'react';
import { BUSINESS } from '../Legal/legalContent';

/** Final header logo — split-tone mark on the purple mob bar. */
export function HeaderBrandMark() {
  return (
    <span className="la-brand-mark" aria-label={BUSINESS.brandName}>
      <img
        className="la-brand-mark__img"
        src="/brand/logos/mobile-7-on-purple.png"
        alt=""
        draggable={false}
      />
    </span>
  );
}
